import { render } from "./MenuModule.vue?vue&type=template&id=2874d050"
import script from "./MenuModule.vue?vue&type=script&lang=js"
export * from "./MenuModule.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__